import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { Button, ButtonType } from '@lean-body/components/atoms';
export const GoalMatchingAssessmentDiagnosisStartPage = ({ onClickNext }) => {
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("img", { className: css(styles.logo), src: "/assets/images/logo-black.svg" }),
        React.createElement("div", { className: css(styles.introductionText) },
            "\u8CEA\u554F\u306B\u7B54\u3048\u308B\u3060\u3051\u3067\u3001AI\u304C\u3042\u306A\u305F\u306B\u3074\u3063\u305F\u308A\u306E\u76EE\u6A19\u3084\u30EC\u30C3\u30B9\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u2728",
            React.createElement("br", null),
            React.createElement("br", null),
            "\u6BCE\u65E5\u306E\u5065\u5EB7\u3065\u304F\u308A\u3092\u3001LEAN BODY\u3068\u4E00\u7DD2\u306B\u697D\u3057\u304F\u306F\u3058\u3081\u307E\u3057\u3087\u3046\uD83D\uDE0A\uD83C\uDF31"),
        React.createElement("img", { src: "/assets/images/goal_matching_assessments/introduction_ai.png", className: css(styles.introductionImg) }),
        React.createElement("div", { className: css(styles.footerButtonBox) },
            React.createElement(Button, { className: css(styles.nextButton), onClick: onClickNext, buttonType: ButtonType.primary, dataTest: "matchingAssessmentNext", fullWidth: true, isRadius: true }, "\u306F\u3058\u3081\u308B"))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100%',
        padding: '50px 36px 0',
        background: Colors.BackgroundAi,
        [MediaBreakPointUp.MD]: {
            paddingBottom: 200,
        },
        [MediaBreakPointUp.XL]: {
            paddingBottom: 150,
        },
    },
    logo: {
        width: 230,
        margin: '0 auto 23px',
    },
    introductionText: {
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '140%',
        letterSpacing: 0.56,
        width: 311,
        marginBottom: 50,
    },
    introductionImg: {
        width: 311,
    },
    footerButtonBox: {
        position: 'fixed',
        textAlign: 'center',
        bottom: 16,
        width: 'calc(100% - 32px)',
        [MediaBreakPointUp.MD]: {
            width: 343,
            margin: '0 auto',
        },
    },
    nextButton: {
        fontSize: 16,
        height: 48,
    },
});
